import {ToolbarOption} from 'platform/components';

/**
 * The formatting an employee gets in every email body, in the order the toolbar shows it.
 *
 * Defined once so the option set cannot drift between the screens that compose an email. It matches
 * the email signature, which is the surface this formatting already shipped on, and the backend
 * sanitizer allows exactly what these options produce.
 */
export const EMAIL_TOOLBAR_OPTIONS: ToolbarOption[] = [
  'bold',
  'italic',
  'underline',
  'listOrdered',
  'listBullet',
  'align',
  'clean',
  'link',
  'image',
];
